import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getToken } from '../../../services/tokenService';

const API = '/api';

export default function useSignature(souscriptionCreee, formData, user, setEtape) {
  // RCDS SMS state
  const [codeSMS, setCodeSMS] = useState('');
  const [codeSMSEnvoye, setCodeSMSEnvoye] = useState(false);
  const [telephoneSignature, setTelephoneSignature] = useState('');
  const [signatureValidee, setSignatureValidee] = useState(false);
  const [demoCode, setDemoCode] = useState(null);
  const [rcdsSmsLoading, setRcdsSmsLoading] = useState(false);

  // FTPE state
  const [ftpeAdhesionId, setFtpeAdhesionId] = useState(null);
  const [ftpeStatus, setFtpeStatus] = useState('pending');
  const [ftpeAccepted, setFtpeAccepted] = useState(false);
  const [ftpeTelephone, setFtpeTelephone] = useState('');
  const [ftpeOtpEnvoye, setFtpeOtpEnvoye] = useState(false);
  const [ftpeSmsLoading, setFtpeSmsLoading] = useState(false);
  const [ftpeCodeOtp, setFtpeCodeOtp] = useState('');
  const [ftpeReferenceVirement, setFtpeReferenceVirement] = useState(null);
  const [ftpeLoading, setFtpeLoading] = useState(false);
  const [isFtpeMember, setIsFtpeMember] = useState(false);

  // === RCDS SMS Handlers ===
  const envoyerCodeSMS = async () => {
    if (!telephoneSignature || telephoneSignature.length < 10) {
      toast.error('Numero de telephone invalide');
      return;
    }
    if (!souscriptionCreee?.id) {
      toast.error('Souscription non creee');
      return;
    }
    setRcdsSmsLoading(true);
    try {
      const token = getToken();
      const response = await axios.post(
        `${API}/souscriptions/${souscriptionCreee.id}/send-signature-sms`,
        { phone_number: telephoneSignature },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        setCodeSMSEnvoye(true);
        toast.success(response.data.message);
        if (response.data.demo_code) {
          setDemoCode(response.data.demo_code);
          toast.info(`Mode demo - Code: ${response.data.demo_code}`, { duration: 10000 });
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi du SMS");
    } finally {
      setRcdsSmsLoading(false);
    }
  };

  const renvoyerCodeSMS = async () => {
    setRcdsSmsLoading(true);
    setCodeSMS('');
    try {
      const token = getToken();
      const response = await axios.post(
        `${API}/souscriptions/${souscriptionCreee.id}/send-signature-sms`,
        { phone_number: telephoneSignature },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        toast.success('Nouveau code envoye !');
        if (response.data.demo_code) {
          setDemoCode(response.data.demo_code);
          toast.info(`Mode demo - Code: ${response.data.demo_code}`, { duration: 10000 });
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors du renvoi du code');
    } finally {
      setRcdsSmsLoading(false);
    }
  };

  const validerCodeSMS = async () => {
    if (!codeSMS || codeSMS.length < 4) {
      toast.error('Code invalide');
      return;
    }
    if (!souscriptionCreee?.id) {
      toast.error('Souscription non creee');
      return;
    }
    setRcdsSmsLoading(true);
    try {
      const token = getToken();
      const response = await axios.post(
        `${API}/souscriptions/${souscriptionCreee.id}/verify-signature-sms`,
        { code: codeSMS, phone_number: telephoneSignature },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.valid) {
        setSignatureValidee(true);
        toast.success('Signature electronique validee !');
        setTimeout(() => setEtape(6), 1500);
      } else {
        toast.error('Code invalide');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Code invalide ou expire');
    } finally {
      setRcdsSmsLoading(false);
    }
  };

  // === FTPE Handlers ===
  const handleCreateFtpeAdhesion = async () => {
    setFtpeLoading(true);
    try {
      const token = getToken();
      const payload = {
        raison_sociale: formData.raison_sociale,
        siret: formData.siret,
        representant_nom: `${formData.prenom_gerant} ${formData.nom_gerant}`,
        representant_email: user?.email || '',
        representant_telephone: telephoneSignature || formData.telephone || '',
        adresse: formData.adresse_entreprise,
        code_postal: formData.code_postal,
        ville: formData.ville,
        territoire: formData.territoire,
        telephone: formData.telephone || telephoneSignature || '0000000000',
        email: user?.email || '',
        code_ape: formData.code_naf || '',
        forme_juridique: formData.forme_juridique || '',
        type_adhesion: 'tpe',
      };
      const response = await axios.post(`${API}/ftpe-adhesion/workflow/create`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFtpeAdhesionId(response.data.adhesion_id || response.data.id);
      setFtpeAccepted(true);
      setFtpeStatus('created');
      toast.success('Adhesion FTPE creee avec succes');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de la creation FTPE');
    } finally {
      setFtpeLoading(false);
    }
  };

  const handleFtpeSendOtp = async () => {
    if (!ftpeTelephone || ftpeTelephone.length < 10) {
      toast.error('Veuillez entrer un numero de telephone valide');
      return;
    }
    setFtpeSmsLoading(true);
    try {
      const token = getToken();
      const response = await axios.post(`${API}/ftpe-adhesion/workflow/${ftpeAdhesionId}/send-sms`,
        { telephone: ftpeTelephone },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFtpeOtpEnvoye(true);
      if (response.data.code_otp) {
        toast.success(`Code FTPE genere : ${response.data.code_otp}`, { duration: 15000 });
      } else {
        toast.success('Code FTPE envoye par SMS');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur envoi SMS FTPE');
    } finally {
      setFtpeSmsLoading(false);
    }
  };

  const handleFtpeValidateSignature = async () => {
    if (!ftpeCodeOtp || ftpeCodeOtp.length < 4) {
      toast.error('Veuillez entrer le code de validation');
      return;
    }
    setFtpeSmsLoading(true);
    try {
      const token = getToken();
      await axios.post(`${API}/ftpe-adhesion/workflow/${ftpeAdhesionId}/validate-signature`,
        { code_otp: ftpeCodeOtp },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFtpeStatus('signed');
      toast.success('Signature FTPE validee !');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Code FTPE invalide');
    } finally {
      setFtpeSmsLoading(false);
    }
  };

  const renvoyerCodeFTPE = async () => {
    setFtpeSmsLoading(true);
    setFtpeCodeOtp('');
    try {
      const token = getToken();
      const response = await axios.post(`${API}/ftpe-adhesion/workflow/${ftpeAdhesionId}/send-sms`,
        { telephone: ftpeTelephone },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.code_otp) {
        toast.success(`Nouveau code FTPE : ${response.data.code_otp}`, { duration: 15000 });
      } else {
        toast.success('Nouveau code FTPE envoye par SMS');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors du renvoi du code FTPE');
    } finally {
      setFtpeSmsLoading(false);
    }
  };

  const handleFtpePaymentVirement = async () => {
    if (!ftpeAdhesionId) {
      toast.error("Veuillez d'abord créer l'adhésion FTPE.");
      return;
    }
    setFtpeLoading(true);
    try {
      const token = getToken();
      // V37.00 — Timeout 25s pour éviter le loader infini en cas de hang
      // Brevo / Cloudflare (cf. V36.87 même pattern sur SEPA GoCardless).
      const response = await axios.post(`${API}/ftpe-adhesion/workflow/${ftpeAdhesionId}/payment-virement`,
        {},
        { headers: { Authorization: `Bearer ${token}` }, timeout: 25000 }
      );
      setFtpeReferenceVirement(response.data.reference_virement || response.data.reference);
      setFtpeStatus('paid');
      toast.success('Paiement FTPE par virement enregistre');
    } catch (error) {
      if (error?.code === 'ECONNABORTED' || /timeout/i.test(error?.message || '')) {
        toast.error('Délai dépassé — le serveur met trop de temps à répondre. Réessayez ou contactez le support.');
      } else {
        toast.error(error.response?.data?.detail || 'Erreur paiement FTPE');
      }
    } finally {
      setFtpeLoading(false);
    }
  };

  const ftpeSigned = ftpeStatus === 'signed' || ftpeStatus === 'paid' || ftpeStatus === 'validated';
  const ftpePaid = ftpeStatus === 'paid' || ftpeStatus === 'validated';

  return {
    // RCDS
    codeSMS, setCodeSMS,
    codeSMSEnvoye, setCodeSMSEnvoye,
    telephoneSignature, setTelephoneSignature,
    signatureValidee, setSignatureValidee,
    demoCode, setDemoCode,
    rcdsSmsLoading,
    envoyerCodeSMS, renvoyerCodeSMS, validerCodeSMS,
    // FTPE
    ftpeAdhesionId, setFtpeAdhesionId,
    ftpeStatus, setFtpeStatus,
    ftpeAccepted, setFtpeAccepted,
    ftpeTelephone, setFtpeTelephone,
    ftpeOtpEnvoye, setFtpeOtpEnvoye,
    ftpeSmsLoading,
    ftpeCodeOtp, setFtpeCodeOtp,
    ftpeReferenceVirement, setFtpeReferenceVirement,
    ftpeLoading,
    isFtpeMember, setIsFtpeMember,
    handleCreateFtpeAdhesion, handleFtpeSendOtp,
    handleFtpeValidateSignature, renvoyerCodeFTPE,
    handleFtpePaymentVirement,
    ftpeSigned, ftpePaid,
  };
}
